import React from 'react';
import styled, {css} from 'styled-components';

import {alpha} from 'utils/ui/colors';
import {pxToRem} from 'utils/ui/units';

import Box from 'components/Box';
import {z} from 'styles/globals';

const height = pxToRem(6);

const Wrapper = styled.div`
	position: relative;
	z-index: ${z.flat};
	overflow: hidden;

	height: ${height};
	border-radius: ${height};

	background-color: ${p => alpha(p.theme.shade, p.theme.shadeStrength)};

	pointer-events: none;
`;

const Bar = styled.div.attrs(p => ({
	style: {transform: `scaleX(${p.progress})`},
}))`
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: ${p => p.theme.links};

	${p =>
		p.dimmed &&
		css`
			background-color: ${alpha(p.theme.shade, p.theme.shadeStrength)};
		`}

	transform: scaleX(0);
	transform-origin: 0 0;

	transition: transform 1s linear;
	will-change: transform;

	${p =>
		p.isSeeking &&
		css`
			transition-duration: 0s;
		`}
`;

const ProgressBar = ({loaded, played, isSeeking, ...otherProps}) => (
	<Box py="s" style={{cursor: 'pointer'}} {...otherProps}>
		<Wrapper>
			<Bar dimmed progress={loaded} isSeeking={isSeeking} />
			<Bar progress={played} isSeeking={isSeeking} />
		</Wrapper>
	</Box>
);

export default ProgressBar;
